//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchHouseDetail, fetchDelete } from '@/api/PMS/baseInformation/house';
import houseAdd from './add';
import houseCustom from './customer';
import houseHistory from './history';
export default {
  components: {
    houseAdd: houseAdd,
    houseCustom: houseCustom,
    houseHistory: houseHistory
  },
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      title: '',
      childData: {},
      list: [],
      multipleSelection: [],
      dialogFormVisible: false,
      dialogCustomerVisible: false,
      dialogHistoryVisible: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      if (this.keyValue > 0) {
        this.getHouseDetail();
      }
    },
    getHouseDetail: function getHouseDetail() {
      var _this = this;

      var queryData = {
        houseId: this.keyValue
      };
      fetchHouseDetail(queryData).then(function (response) {
        _this.childData = response.data.data;
      });
    },
    handleUpdate: function handleUpdate() {
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      this.$confirm('你确定是要删除该房间, 是否继续?', '提示').then(function () {
        fetchDelete([_this2.keyValue]).then(function (response) {
          _this2.$emit('handDetailCancle');

          _this2.Alert({
            alertType: 'delete'
          });
        });
      });
    },
    // 绑定业主
    changeProprietor: function changeProprietor() {
      this.title = '绑定业主';
      this.dialogCustomerVisible = true;
    },
    // 绑定业主历史记录
    changeProprietorHis: function changeProprietorHis() {
      this.title = '绑定业主历史记录';
      this.dialogHistoryVisible = true;
    },
    handleContractDetail: function handleContractDetail() {},
    handleCustomerDetail: function handleCustomerDetail() {},
    handCancle: function handCancle() {
      this.$emit('handCancle', true);
      this.getHouseDetail();
      this.dialogFormVisible = false;
      this.dialogCustomerVisible = false;
      this.dialogHistoryVisible = false;
    }
  }
};